import React from 'react';

const MarkedPdfViewer = ({ url }) => {
  if (!url) return null;

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-200">
        <h3 className="text-sm font-semibold text-gray-900">Marked Script Preview</h3>
      </div>
      <iframe
        src={url}
        title="Marked PDF"
        className="w-full border-0"
        style={{ height: '80vh' }}
      />
    </div>
  );
};

export default MarkedPdfViewer;
